const observer = new MutationObserver((mutationList, observer) => {
  mutationList.forEach((mutation) => {
    if (mutation.type === "childList") {
      // Check if the target element is added
      const klaviyoForm = document.querySelector('.klaviyo-form');
      if (klaviyoForm) {
        klaviyoForm.querySelectorAll('div[data-testid="form-row"]').forEach(parent => {
          const children = parent.querySelectorAll('div[data-testid="form-component"]');
          if (children.length === 2) {
            parent.classList.add('has-two-children');
          }
        });
        // observer.disconnect();
      }
    }
  });
});

// Options for the observer (monitor the whole body for additions)
const config = { childList: true, subtree: true };

// Start observing the body
observer.observe(document.body, config);
